import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";

import {
  listarOportunidades,
  listarOportunidadesPorFiltro,
  gerarExelOportunidades,
} from "../../../services/http/oportunidadeService";

import { trackPromise } from "react-promise-tracker";
import { useSnackBar } from "../../../hooks/snackBar";
import ListOportunidade from "./ListOportunidade";
import { saveAs } from "file-saver";

import "./styles.scss";

const Oportunidade = () => {
  const history = useHistory();
  const { addSnackBar } = useSnackBar();
  const [busca, setBusca] = useState("");
  const [oportunidades, setOportunidades] = useState({
    numeroPagina: 0,
    totalPaginas: 0,
    lista: [],
    tamanhoPagina: 0,
    hasPreviousPage: false,
    hasNextPage: false,
  });

  const CarregarListaOportunidadesComFiltro = (filtro, pagina) => {
    trackPromise(
      listarOportunidadesPorFiltro(filtro, pagina).then((res) => {
        if (res.data) {
          setOportunidades(res.data);
        }
      })
    ).catch((error) => {
      console.log(error);
    });
  };

  const extrairBase = () => {
    trackPromise(
      gerarExelOportunidades().then((res) => {
        if (res.data) {
          saveAs(res.data, "Oportunidades.xlsx");
        } else {
          addSnackBar({
            message: "Não foi possível extrair a base de oportunidades",
            info: "warning",
            open: true,
          });
        }
      })
    ).catch((error) => {
      addSnackBar({
        message: "Erro ano extrair a base de oportunidades",
        info: "error",
        open: true,
      });
    });
  };

  const mudarPaginaOportunidade = (page) => {
    CarregarListaOportunidadesComFiltro(busca, page);
  };

  const buscar = (filtro) => {
    setBusca(filtro);
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      CarregarListaOportunidadesComFiltro(busca, 1);
    }, 2000);
  }, [busca]);

  useEffect(() => {
    CarregarListaOportunidadesComFiltro(busca, 1);
  }, []);

  return (
    <div>
      <div className="row">
        <h1 className="col-sm-12 col-md-12 col-lg-12 titulo">
          Histórico de Oportunidades
        </h1>
      </div>

      <div className="row">
        <div className="col-sm-4 col-md-4 col-lg-4 my-1">
          <button
            onClick={() => history.push("/oportunidade/cadastro")}
            className="buton-green btn btn-block btn-lg mt20"
          >
            CADASTRAR OPORTUNIDADE
          </button>
        </div>

        <div className="col-sm-4 col-md-4 col-lg-4 my-1">
          <button
            className="buton-white-black-border btn btn-block btn-lg mt20"
            onClick={extrairBase}
          >
            EXTRAIR BASE
          </button>
        </div>
      </div>
      <ListOportunidade
        response={oportunidades}
        mudarPagina={mudarPaginaOportunidade}
        buscar={buscar}
        busca={busca}
      />
    </div>
  );
};

export default Oportunidade;
